import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './Pis.css';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import WeekSlider from '../common/WeekSlider';
import Cookies from "js-cookie";
import * as actions from '../Actions';
import withContext from "../../../withContext";

const service = new Service();

class Pis extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        let currentweek = 0;
        
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData && serverSideData['result']) {
            initialData = serverSideData['result'];
            currentweek = initialData.currentWeek;
        }
        console.log("serverSideData", serverSideData);
        this.state = {
            initialData: initialData,
            currentweek: parseInt(currentweek),
            clickwedWeek: parseInt(currentweek),
            pisStyle: this.getTestStyleObj(initialData),
            WeekSliderData: this.getWeekSliderData(initialData),
            isCurrentWeekscroll: true,
            isOverviewActive:false,
            dueDate: '',
            loadAlltest: '',
            scrollwidth: 0,
            halfwidth: 0,
            weekwd: 0,
            weeks: [],
            trimester_txt: 'First Trimester',
            IsExpected: false,
            isApp: false,
            checkGraph : true,
            currentStatus:'all',
            metaTitle: "Pregnancy Checkup Schedule – Tests, Screening, Scans & more",
            metaDescription: [
                { "name": "description", "content": "Prenatal medical care is most important to monitor the health of pregnant woman and baby. Find more about checkups to be done during pregnancy for a healthy baby & You. Get more information about antenatal care at FirstCry Parenting." },
                { "name": "keywords", "content": "prenatal care, pregnancy checkup, medical examination during pregnancy" },
                { "name": "atdlayout", "content": "tools_sp" }
            ]
        };
        this.timeout = 0;
        this.weeksOnSide = 0;
        this.testClassObj = {
            "upcoming": "bar-upcome",
            "overdue": "bar-overdue",
            "done": "bar-done",
        }
        this.isChatJsLoaded = false;
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        // var url = global.api_url + "preginspection/getpregnancyinspectiontest";
        var url = global.api_url + "preginspection/getpregnancyinspectiontestgraphview";
        let body = JSON.stringify({});
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        this.callOnScroll = this.callOnScroll.bind(this);
        if (this.props.location.search.includes('from=app')) {
            this.setState({ isApp: true });
        }
        document.querySelector('.preg-scroll').addEventListener("scroll", this.callOnScroll, false);
        console.log(this.state.initialData);
        document.getElementsByClassName('pregnancy-reports')[0].style.width = document.getElementsByClassName('preg-scroll')[0].offsetWidth + 'px';
        // debugger;
        let trimesterbottom = document.querySelector(".preg-scroll").offsetHeight - document.querySelector(".pregn-reports-cnt").offsetHeight - 40 - 10;
        // document.querySelector(".trimester-txt").style.bottom = trimesterbottom + "px";

        if (global.userAry['IsExpected']) {
            this.setState({ IsExpected: true });
        } else {
            this.setState({ IsExpected: false });
        }
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                this.pisData("Piechart");
            } else {
                localStorage.setItem('pisDataLanding', JSON.stringify(this.state.initialData));
                this.setViewStates();
                this.getPisData();
            }
        } else {
            if (localStorage.getItem('pisDataLanding')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('pisDataLanding')),
                    pisStyle: this.getTestStyleObj(JSON.parse(localStorage.getItem('pisDataLanding'))),
                    WeekSliderData: this.getWeekSliderData(JSON.parse(localStorage.getItem('pisDataLanding'))),
                    currentweek: parseInt(JSON.parse(localStorage.getItem('pisDataLanding')['currentWeek'])),
                    clickwedWeek: parseInt(JSON.parse(localStorage.getItem('pisDataLanding')['currentWeek']))
                }, () => { this.setViewStates(); this.getPisData(); });
            }
            service.hideLoader();
        }


    }
    getPisData() {
        service.showLoader();
        if(this.state.checkGraph){
            setTimeout(() => {
                if (global.ftk && this.state.IsExpected) {
                var weekcount = this.state.clickwedWeek && document.querySelector('.startweek_' + this.state.clickwedWeek) != null ? parseInt(document.querySelector('.startweek_' + this.state.clickwedWeek).id) : document.querySelector('.endweek_' + this.state.clickwedWeek) ? parseInt(document.querySelector('.endweek_' + this.state.clickwedWeek).id) : this.state.clickwedWeek ;
                var headerHeight = document.getElementsByTagName('header') ? document.getElementsByTagName('header')[0].clientHeight : 1;
                var titleHeight = document.querySelector('.title') ? document.querySelector('.title').clientHeight + 10 : 1;
                var MainDivHeight = document.querySelector('.pregnancy-inspt').clientHeight - document.querySelector('.contentList').clientHeight;
                var divHeight = document.querySelector('.pis_toggle_view').clientHeight + 10 + (document.querySelector('.content_chart-pregnancy').clientHeight * weekcount) + headerHeight + titleHeight + MainDivHeight;
                if(this.state.isCurrentWeekscroll){
                    this.setState({isCurrentWeekscroll:false}); 
                    window.scrollTo(0, (divHeight));
                }
                 
                }
            }, 2000)
        

        this.getStatsData();
        this.loadTest(this.state.currentStatus);
        }
    }
    getStatsData() {
        if (this.state.IsExpected && global.userAry['childData']['UserChildList'][0] && global.userAry['childData']['UserChildList'][0].DOB) {
            var Duedate = new Date(global.userAry['childData']['UserChildList'][0].DOB);
            var conDuedate = Duedate.getDate() + "/" + (Duedate.getMonth() +1) + "/" + Duedate.getFullYear();
            this.setState({dueDate:conDuedate});
           
        }
        var sublistul = [100];
        var clr = ["#fc88af"];
        if (this.state.IsExpected) {
            sublistul = [this.state.initialData.overdueCount + 1, this.state.initialData.doneCount + 1, this.state.initialData.upcomingCount + 1];

            clr = ["#ee534f", "#27a63f", "#f5b819"];
        }
        if (this.isChatJsLoaded) {
            actions.pispiechart(sublistul, clr, this);
        } else {
            service.loadChatJsFile(this);
        }

    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.callOnScroll, false);
    }

    getWeekSliderData(initialData) {
        let WeekSliderData = [];
        let totalWeek = (initialData && initialData.totalWeek) ? parseInt(initialData.totalWeek) : 40;
        for (let i = 0; i < totalWeek; i++) {
            WeekSliderData.push({ week: (i + 1) });
        }
        return WeekSliderData;
    }

    setViewStates() {
        this.setState({
            scrollwidth: document.querySelector('.preg-scroll').offsetWidth,
            halfwidth: document.querySelector('.preg-scroll').offsetWidth / 2,
            weekwd: document.querySelector('.week-bar li').offsetWidth,
            weeks: document.querySelectorAll('.week-bar li')
        }, () => { this.setScrollView(); });
    }

    setScrollView() {
        let a;
        let scrolllft = 0;
        for (let j = 1; j <= document.querySelectorAll('.week-bar li').length; j++) {
            let wd = j * this.state.weekwd;
            if (wd > this.state.halfwidth) {
                a = j - 1;
                this.weeksOnSide = a;
                break
            }
        }
        for (let i = 0; i <= document.querySelectorAll('.week-bar li').length; i++) {
            if (this.state.weeks[i] && this.state.weeks[i].classList && this.state.weeks[i].classList.contains('sel-week')) {
                scrolllft = (this.state.weekwd * (i - a));
                document.querySelector('.preg-scroll').scrollLeft = scrolllft;
                document.getElementsByClassName('pregnancy-reports')[0].style.width = (document.getElementsByClassName('preg-scroll')[0].offsetWidth + scrolllft)
                this.setTrimesterText(this.state.clickwedWeek);
                break
            }
        }
    }

    callOnScroll() {
        let leftPos = document.querySelector('.preg-scroll').scrollLeft;
        if (document.getElementsByClassName('pregnancy-reports')[0].offsetWidth <= document.querySelector('.weeks-section').offsetWidth) {
            document.getElementsByClassName('pregnancy-reports')[0].style.width = (document.getElementsByClassName('preg-scroll')[0].offsetWidth + leftPos) + 'px';
        }
        var scroll_width = document.querySelector('.preg-scroll').offsetWidth;
        if (leftPos !== 0 && (scroll_width + leftPos) < document.querySelector('.week-bar').offsetWidth) {
            let weekno = Math.floor((leftPos) / this.state.weekwd) + this.weeksOnSide + 1;
            this.setState({ clickwedWeek: weekno });
            this.setTrimesterText(weekno);
        }
    }

    setTrimesterText(weekno) {
        this.setState({ trimester_txt: actions.getPragnancyTrimesterText(weekno) });
    }

    pisData(check) {

        service.showLoader();
        var url;
        if (check == "GraphView") {
            url = global.api_ci_url + "Pis/getPisLandingData";
            this.setState({checkGraph : false});
        } else {
            url = global.api_ci_url + "api/fetchfromCI/preginspection~getpregnancyinspectiontestgraphview"
            this.setState({checkGraph : true});

        }
        var postData = {}

        service.postServiceCall(url, postData).then((json) => {
            console.log(json);
            if (json['result']) {


                let testLatestData = '';

                if(this.state.currentStatus=="done"){
                    var elems = document.querySelectorAll(".checkAll");

                    [].forEach.call(elems, function(el) {
                        el.classList.add("isMarkChecked");
                        el.setAttribute('data-icon-font', "A");
                    });

                    testLatestData = json['result']['doneList'];
                }else if(this.state.currentStatus=="overdue"){

                    var elems = document.querySelectorAll(".checkAll");

                    [].forEach.call(elems, function(el) {
                        el.classList.remove("isMarkChecked");
                        el.setAttribute('data-icon-font', "z");
                    });

                    testLatestData = json['result']['overDueList'];
                }else if(this.state.currentStatus=="upcoming"){
                    var elems = document.querySelectorAll(".checkAll");

                    [].forEach.call(elems, function(el) {
                        el.classList.remove("isMarkChecked");
                        el.setAttribute('data-icon-font', "z");
                    });

                    testLatestData = json['result']['upcomingList'];
                }else{
                    testLatestData = json['result']['test'];
                }

                this.setState({
                    initialData: json['result'],
                    loadAlltest: testLatestData,
                    pisStyle: this.getTestStyleObj(json['result']),
                    WeekSliderData: this.getWeekSliderData(json['result']),
                    currentweek: parseInt(json['result']['currentWeek']),
                    clickwedWeek: parseInt(json['result']['currentWeek'])
                }, () => { service.showLoader(); this.setViewStates(); this.getPisData(); });
                localStorage.setItem('pisDataLanding', JSON.stringify(json['result']));
            }
                setTimeout(() => {
                    service.hideLoader();
                }, 2000);
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    getTestStyleObj(data) {
        let testAry = [];
        if (data.test) {
            testAry = data.test;
        }
        let styleObj = {};
        for (let i = 0; i < testAry.length; i++) {
            let test = testAry[i];
            let topObj = {
                "6testid631": "0",
                "6testid601": "0",
                "6testid611": "0",
                "6testid661": "0",
                "6testid671": "0",
                "6testid641": "0",
                "6testid651": "55px",
                "6testid6a1": "55px",
                "6testid6b1": "55px",
                "6testid632b1": "55px",
                "6testid632a1": "55px",
                "6testid63291": "111px",
                "6testid63281": "111px",
                "6testid632f1": "111px",
                "6testid632e1": "111px",
                "6testid632d1": "167px",
                "6testid632c1": "167px",
                "6testid63231": "167px",
                "6testid63221": "223px",
                "6testid602b1": "223px",
                "6testid602a1": "280px",
                "6testid60291": "280px",
                "6testid60281": "336px",
                "6testid602f1": "336px",
                "6testid602e1": "336px",
                "6testid602d1": "393px",
                "6testid602c1": "450px",
                "6testid60231": "506px",
                "6testid60221": "563px",
                "6testid612b1": "620px"
            }
            let weekwd = (this.state && this.state.weekwd && this.state.weekwd > 0) ? this.state.weekwd : 85;
            let obj = {
                width: ((test.endWeek - test.startWeek + 1) * weekwd) + "px",
                left: ((test.startWeek - 1) * weekwd) + "px",
                top: topObj[test.id]
            }
            styleObj[test.id] = obj;
        }
        return styleObj;
    }

    manageReport(id, title) {
        if (global.ftk != '') {
            if (this.state.IsExpected) {
                let newTitle = title.trim().replace(/\s/g, "_").replace(/\//g, "+");
                window.location.href = service.getRedirectUrl("/tools/pregnancy-checkup-schedule/manageReports/" + newTitle + '/' + id)
                // this.props.history.push(service.getRedirectUrl("/tools/pregnancy-checkup-schedule/manageReports/" + newTitle + '/' + id));
            } else {
                document.querySelector('.define-duedate').style.display = 'block';
            }
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }

    addDuedate() {
        this.closeDuedatePopup();
        window.location.href = '/my-account?URL=' + global.currentURL;
    }

    closeDuedatePopup() {
        document.querySelector('.define-duedate').style.display = 'none';
    } 
    loadTest(checkArgu, e, IsExpected) {
        this.setState({currentStatus:checkArgu});

        if(Cookies.get("upCommingtest")=="1"){
            document.querySelector('.one-upcoming').classList.add('activeTab');            
            this.setState({isCurrentWeekscroll:false}); 

        }


        service.showLoader();
        let loadTest, flag = 0;
        Cookies.get("upCommingtest") == "1" ? checkArgu = "upcoming" : checkArgu = checkArgu;
        Cookies.set("upCommingtest", "");
        Cookies.set("chartType","Piechart");
        Cookies.set("activeCheckArgu",checkArgu);
        // Cookies.get("upCommingtest") == "activeTab_upcomming" ? checkArgu = "upcoming" : checkArgu = checkArgu;
        // Cookies.set("upComminglist", "activeTab_upcomming");

        var eleList = document.querySelectorAll('.content-list-view-pie');
        
        if (e && e.target.classList.contains("activeTab") && e.target.id == checkArgu) {
            checkArgu = "all";
        }
        if (global.ftk != '' || checkArgu == 'all') {
            if (IsExpected) {
                document.querySelector('.define-duedate').style.display = 'block';
                
                return false;
            }
            if (checkArgu == "all") {  
                loadTest = this.state.initialData && this.state.initialData.test;
            } else if (checkArgu == "overdue") {
                if (this.state.initialData && this.state.initialData.overdueCount == "0") {
                    flag = 1;
                } else {
                    loadTest = this.state.initialData && this.state.initialData.overDueList;
                    document.querySelector('.one-upcoming').style.backgroundColor = '';
                    //e.target.style.backgroundColor = 'pink';

                }
                
            } else if (checkArgu == "done") {
                if (this.state.initialData && this.state.initialData.doneCount == '0') {
                    flag = 1;
                } else {
                    loadTest = this.state.initialData && this.state.initialData.doneList;
                    document.querySelector('.one-upcoming').style.backgroundColor = '';
                    //e.target.style.backgroundColor = 'green';

                }
            } else {
                if (this.state.initialData && this.state.initialData.upcomingCount == "0") {
                    flag = 1;
                } else {
                    // !document.querySelector('.one-upcoming').classList.contains('activeTab') && (document.querySelector('.one-upcoming').classList.add('activeTab'));
                    loadTest = this.state.initialData && this.state.initialData.upcomingList;
                    // e.target.style.backgroundColor = 'orange';
                    // document.querySelector('.one-upcoming').classList.add('activeTab');
                    //document.querySelector('.one-upcoming').style.backgroundColor = 'orange';
                }
            }

            if (flag == 1) {
                
                document.querySelector('.showEmptyPopup').style.display = "block";
                setTimeout(() => {
                    
                   document.querySelector("#overdue").classList.remove("activeTab");
                   document.querySelector("#done").classList.remove("activeTab");
                   document.querySelector("#upcoming").classList.remove("activeTab");
                    
                    document.querySelector('.showEmptyPopup').style.display = "none";
                    // service.showLoader();
                     
                     this.setState({currentStatus:'all'});
                     this.loadTest(this.state.currentStatus);
                     this.setState({isCurrentWeekscroll:false});


                }, 2000)
            } else {
                /*for (var i = 0; i < eleList.length; i++) {
                    if (eleList[i].classList.contains("activeTab")) {
                        eleList[i].classList.remove("activeTab");
                        eleList[i].style.backgroundColor = '';

                        // service.hideLoader();
                        // return false;
                    }

                }*/
 
                // e && e.target.classList.add("activeTab");
                setTimeout(() => {
                    this.setState({ loadAlltest: loadTest }, () => { /*service.hideLoader();*/ })
                }, 1000)
            }  
            if(e && e.target.classList.contains("activeTab")){
                e && e.target.classList.remove("activeTab");
                  document.querySelector("#overdue").classList.remove("activeTab");
                  document.querySelector("#done").classList.remove("activeTab");
                  document.querySelector("#upcoming").classList.remove("activeTab");
            // this.setState({isOverviewActive:true});
            }else if(e){
                  document.querySelector("#overdue").classList.remove("activeTab");
                  document.querySelector("#done").classList.remove("activeTab");
                  document.querySelector("#upcoming").classList.remove("activeTab");
                e && e.target.classList.add("activeTab");
                // this.setState({isOverviewActive:false});   
            }
            service.hideLoader();
        } else {
            service.hideLoader();
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }

    render() {
        return (
            <main className="main-container pis-main-content-popup">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />

                <div className="title mobileview_pis_header">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Pregnancy Inspection Schedule</span>
                    </div>
                    <div className="preg-inp">
                        <h1 className="B24_00" id="skipToH1" tabIndex={0}>Pregnancy Inspection Schedule</h1>
                        <Link to={service.getRedirectUrl("/tools/pregnancy-checkup-schedule/how-it-work")} className="right">
                            <span className="icon i-icon" data-icon-font=""></span>
                        </Link>
                    </div>
                </div>
                {this.state.isApp &&
                    <div className="preg-inp preg-inp-app">
                        <h1 className="B24_00" id="skipToH1" tabIndex={0}>Pregnancy Inspection Schedule</h1>
                        <Link to={service.getRedirectUrl("/tools/pregnancy-checkup-schedule/how-it-work")} className="right">
                            <span className="icon i-icon" data-icon-font=""></span>
                        </Link>
                    </div>
                }
                <div className="sub-container left ganchart-mobile-view-pis">
                    <div className="pis-landing data-container left">
                        <div className="pis_toggle_view">
                        <input type="hidden" name="view" value= {this.state.dueDate}/> 
                            <div className="pis_toggle_view-text left"> Toggle for different view </div>
                            <div className="right veg-non-veg">
                                <span className="view-graph-only R15_9e left"> Graph View</span>
                                <div className="online-toggle right toggle_pis" onClick={(e) => actions.pisTogglegraph(e, this)}></div>

                            </div>
                        </div>
                        <div className="pregnancy-inspt" >
                           <div className="pis_mobile_view_piechart360">
                            <div className="pis-mainviewinspt">
                                <div className="ips-pregnacy-inspt ganchart-view-pis pis-add-cl">
                                    <div className="pregnancy-top">
                                        <div className="inspection">
                                            <div className="pregnancy sub_1">
                                                <div className="pregnancy-inner sub_inner_1">
                                                    <p>{(this.state.initialData && this.state.initialData.overdueCount) ? this.state.initialData.overdueCount : '0'}</p>
                                                </div>
                                            </div>
                                            <p className="preg-txt left">Overdue</p>
                                        </div>
                                        <div className="inspection upcoming">
                                            <div className="pregnancy sub_2">
                                                <div className="pregnancy-inner sub_inner_2">
                                                    <p>{(this.state.initialData && this.state.initialData.upcomingCount) ? this.state.initialData.upcomingCount : '0'}</p>
                                                </div>
                                            </div>
                                            <p className="preg-txt left">Upcoming</p>
                                        </div>
                                        <div className="inspection">
                                            <div className="pregnancy sub_3">
                                                <div className="pregnancy-inner sub_inner_3">
                                                    <p>{(this.state.initialData && this.state.initialData.doneCount) ? this.state.initialData.doneCount : '0'}</p>
                                                </div>
                                            </div>
                                            <p className="preg-txt left">Done</p>
                                        </div>
                                    </div>
                                    <div className="preg-scroll">
                                        <div className="pregn-reports-cnt">
                                            <div className="pregnancy-reports">
                                                <ul className="preg-tests">
                                                    {this.state.initialData && this.state.initialData.test && this.state.initialData.test.length > 0 && this.state.initialData.test.map((test, index) =>
                                                        <li key={index} id={test.id} className={`tests ${this.testClassObj[test.status]}`} style={this.state.pisStyle[test.id]} onClick={() => this.manageReport(test.id, test.title)}>
                                                            <span className="dev_testTitle">{test.title}</span>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                            <WeekSlider eleRef={this} WeekBdata={this.state.WeekSliderData} weekKey={'week'} keyVal={1} tool={'pis'} />
                                            <div className="trimester-cnt">
                                                <div className="trimester fst-trimester" style={{ width: (this.state.weekwd * 12) + "px" }}>
                                                    <span></span>
                                                </div>
                                                <div className="trimester sec-trimester" style={{ width: (this.state.weekwd * 14) + "px" }}>
                                                    <span></span>
                                                </div>
                                                <div className="trimester trd-trimester" style={{ width: ((this.state.weekwd * 14) + 40) + "px" }}>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ips-pregnacy-inspt nutritional pis-add-cl">
                                    <div className="pregnancy-top">
                                        <div className="pie-chart-chartparent">
                                            <div className="pie-chart-circle-view">
                                                <div className="chart-container">
                                                    <canvas id="myChart" width="242" height="242"></canvas>
                                                </div>
                                            </div>
                                            <div className="pie-chart-list-view">
                                                <div className="pie-overdue-common">
                                                    <div className="content-list-view-pie one-overdue" id="overdue" onClick={(e) => this.loadTest("overdue", e, !this.state.IsExpected)}> Overdue ({(this.state.initialData && this.state.initialData.overdueCount) ? this.state.initialData.overdueCount : '0'}) </div>
                                                    <div className="content-list-view-pie one-Done" id="done" onClick={(e) => this.loadTest("done", e, !this.state.IsExpected)}> Done ({(this.state.initialData && this.state.initialData.doneCount) ? this.state.initialData.doneCount : '0'}) </div>
                                                    <div className="content-list-view-pie one-upcoming" id="upcoming" onClick={(e) => this.loadTest("upcoming", e, !this.state.IsExpected)}> Upcoming ({(this.state.initialData && this.state.initialData.upcomingCount) ? this.state.initialData.upcomingCount : '0'})</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="showEmptyPopup gr_main_overlay_pis">
                                    <div className="pis-popup-main-overlay">
                                        <div className="pis-search_profile_div">
                                            {/* <img src="../../../../images/Search_Results.png" alt="logo"/> */}
                                            <img src={require('../images/pis/Search_Results.png')} alt="logo" />
                                        </div>
                                        <div className="pis-content-view-scans-popup">
                                            <h2 className="M24_21"> Oouh.. its empty in here </h2>
                                            <p className="R18_75"> You dont have any Tests/Scans in this list </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="trimester-txt">{this.state.trimester_txt}</div>
                            {global.ftk == '' ?
                                (<div className="pie_chart-loginview pie_chart1">
                                    <div className="pie_chart-login-text M18_42"> Please login to View Complete Details</div>
                                    <a href={service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL)} target="">
                                        <button className="login-registerbtn M16_white" type="text"> Login / Register </button>
                                    </a>
                                </div>) :
                                !this.state.IsExpected ?
                                    <div className="pie_chart-loginview pie_chart1">
                                        <div className="pie_chart-login-text M18_42"> Hi {global.userAry['userName']}! Please enter the due date details</div>
                                        <a href={service.getRedirectUrl('/my-account?URL=' + global.currentURL)} target="">
                                            <button className="login-registerbtn M16_white" type="text"> Add Due Date in Profile </button>
                                        </a>
                                    </div>
                                    :
                                    <div className="pie_chart-loginview pie_chart2">
                                        <div className="date-days-pegment estimated_due"> Your estimated due date: {this.state.dueDate} </div>
                                        <div className="pie_chart-login-text M18_42"> {(this.state.initialData && this.state.initialData.remdate) ? this.state.initialData.remdate : 'NA'}</div>
                                        <div className="date-days-pegment estimated_due_Trimester"> {(this.state.initialData && this.state.initialData.Trimster) ? this.state.initialData.Trimster : 'NA'} </div>
                                    </div>
                                    
                            }
                            </div>
                            <div className="contentList">
                                {this.state.checkGraph && this.state.loadAlltest && this.state.loadAlltest.map((test1, index1) =>
                                    <div key={index1} className={`content_chart-pregnancy startweek_${test1.startWeek} endweek_${test1.endWeek}`} id={index1 + "_test"}>
                                        <div className="pis-content-main-div" id={test1.status == 'overdue' ? "testoverdue" : test1.status == 'upcoming' ?  "testupcoming" : "testDone" }>
                                            {global.ftk && this.state.IsExpected &&
                                                <div className="left-color-indication" style={test1.status == 'overdue' ? { background: "#ee534f" } : test1.status == 'upcoming' ? { background: "#f5b819" } : { background: "#27a63f" }}></div>
                                            }
                                            <div className="common-number_of_weekdays">
                                                <h2> {test1.title} </h2>
                                                <div className="left-weekdays_div">

                                                    <div className="R16_9e pis-week-bottom-m"> {`(Week ${test1.startWeek} to Week ${test1.endWeek})`}</div>
                                                </div>
                                                <div className="right-weekdays_div">
                                                     {this.state.IsExpected && ((test1.status == 'upcoming' && (test1.dueOnFlag == 1 ) || test1.status == 'done' || test1.status == 'overdue')) &&
                                                        <div className="float-field">
                                                            <span className="R16_9e check-text" >{test1.status == 'done' ? 'Test Done' : 'Mark as Done'}</span>
                                                            {test1.status == 'done' ?
                                                                (<span className={test1.status == 'done' ? "icon select-all checkbox checkAll isMarkChecked" : "icon select-all checkbox checkAll"} data-status={test1.status}  data-icon-font="A" id="setpic" value="0" onClick={(e) => { actions.pisTestdone(e, test1.id, this) }}></span>) :
                                                                (<span className="icon select-all checkbox checkAll" data-icon-font="z" id="setpic" value="0" onClick={(e) => { actions.pisTestdone(e, test1.id, this) }}></span>
                                                                )}
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            {global.ftk && this.state.IsExpected &&
                                                <div className="pie_due_dates">
                                                    <span className="icon calendar-icon" data-icon-font="w"></span>
                                                    <div className="due_dates-view">
                                                        <span className="M15_42"> {test1.status == 'overdue' 
                                                        ? 'Pending Since:'
                                                            : test1.status == 'done' ? 'Test Done on:' : (test1.status == 'upcoming' && test1.dueOnFlag == 1 ) ? 'Currently Due:' : 'Test Due on:'} </span>
                                                        
                                                        {test1.status == 'done' ? <span className="M15_42 doneDate"> {test1.givenOn && test1.givenOn.split(" ")[1]},{test1.givenOn.split(" ")[0]}</span>
                                                            : <span className="M15_42"> {test1.dueOn && test1.dueOn.split(" ")[1]},{test1.dueOn.split(" ")[0]}</span>}
                                                    </div>
                                                </div>
                                            }
                                            <div className="pis-dsicription-pra gtm-test" onClick={() => this.manageReport(test1.id, test1.title)}>
                                                <p className="gtm-test">{test1.desc}</p>
                                                <span className="gtm-test"> Read more </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="define-duedate">
                    <div className="duedate-msg">
                        {/* <div className="R15_42">For using this tool due date need to be defined in system</div> */}
                        <div className="R15_42">To see the complete details on this tool, Please add “due date” to your profile. Do you wish to update?</div>
                        <div className="sel-opt M15_75">
                            <span className="yesno" id="no" onClick={() => this.closeDuedatePopup()}>No</span>
                            <span className="yesno M15_fc88af" id="yes" onClick={() => this.addDuedate()}>Yes</span>
                        </div>
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withContext(Pis);
